import { TwRecintoViewModel } from 'src/app/components/_campanias/recintos/recinto.types';

export class NavMenuServiceRecinto {
    protected _currentRecinto: TwRecintoViewModel | undefined = new TwRecintoViewModel();

    protected refresh(): void {
        // TO BE OVERRIDEN IN THE PARENT
    }

    protected resetRecintoData(): void {
        this._currentRecinto = new TwRecintoViewModel();
    }

    protected set currentRecinto(value: TwRecintoViewModel) {
        this._currentRecinto = value;
        this.refresh();
    }

    protected get currentRecinto(): TwRecintoViewModel {
        if (!this._currentRecinto) {
            this._currentRecinto = new TwRecintoViewModel();
        }
        return this._currentRecinto;
    }

    public updateMenuServiceForRecinto(id: number): void {
        const vm = new TwRecintoViewModel();
        vm.Id = id;
        this.currentRecinto = vm;
    }

    public clearMenuServiceForRecinto(): void {
        const vm = new TwRecintoViewModel();
        vm.Id = 0;
        this.currentRecinto = vm;
    }

    protected get isRecintoSelected(): boolean {
        if (this.currentRecinto && this.currentRecinto.Id) {
            return this.currentRecinto.Id > 0;
        } else return false;
    }
}
